



























































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { ToastProgrammatic as Toast } from 'buefy';
import { Group, User } from '../../../store/modules/admin/types/admin.types';
import {
  AddGroupsToRoleDto,
  AddUsersToRoleDto,
  GroupIdTypeName,
  ResourceTypes
} from '../../../store/modules/roles-and-permissions/types/roles-and-permissions.types';
import { RootState } from '../../../store/store';
import { ApiState } from '../../../store/types/general.types';
import SelectGroupListComponent from './SelectGroupListComponent.vue';
import SelectUserListComponent from './SelectUserListComponent.vue';
import SelectRoleListComponent from './SelectRoleListComponent.vue';
import { RoleSansTree } from '../../../store/modules/role/types/role.types';
import {
  Product,
  ApplicationItems,
  InviteUserFormValues,
  ProductInvitationDto
} from '../../../store/modules/application/types/application.types';
import InviteNewUserForm from './InviteNewUserForm.vue';
import { Job } from 'bull';

@Component({
  components: {
    SelectUserListComponent,
    SelectGroupListComponent,
    SelectRoleListComponent,
    InviteNewUserForm
  }
})
export default class AssignToRoleModal extends Vue {
  @Prop() public role!: RoleSansTree | undefined;
  @Prop() public resourceType!: ResourceTypes | undefined;
  @Prop() public selectedUser!: User | null;
  @Prop() public selectedGroup!: Group | null;

  public stepsIndex: number = 0;
  public isInviteButtonDisable: boolean = true;
  public selectedUsers: Array<Partial<User>> = [];
  public selectedResources: User[] | Group[] = [];
  public userListComponentKey: number = 0;
  public groupListComponentKey: number = 0;
  public newUserInvitesPayload: ProductInvitationDto[] = [];
  public selectedRoles: RoleSansTree[] = [];
  public payload: {
    resourceType: ResourceTypes;
    resourceIds: number[] | GroupIdTypeName[];
    roleId?: number | number[];
  } = {
    resourceType: this.resourceType ? this.resourceType : ResourceTypes.USER,
    resourceIds: [],
    roleId: this.role ? this.role.id : undefined
  };
  public formData: InviteUserFormValues = {
    email: '',
    firstName: '',
    lastName: '',
    productId: 0
  };

  @Action('rolesAndPermissions/addUserToRoles')
  public addUserToRoles!: (params: {
    payload: AddUsersToRoleDto;
  }) => Promise<Job[] | void>;

  @State(
    ({ rolesAndPermissions }: RootState) =>
      rolesAndPermissions.apiState.addUserToRoles.success
  )
  public addUsersToRoleSuccessState!: boolean;

  @State(
    ({ rolesAndPermissions }: RootState) =>
      rolesAndPermissions.apiState.addUserToRoles.error
  )
  public addUsersToRoleErrorState!: boolean;

  @State(
    ({ rolesAndPermissions }: RootState) =>
      rolesAndPermissions.apiState.addUserToRoles.error
  )
  private addUsersToRoleErrorMessage!: string | null;

  @Action('rolesAndPermissions/addGroupToRoles')
  private addGroupToRoles!: (params: {
    payload: AddGroupsToRoleDto;
  }) => Promise<void>;

  @State(
    ({ rolesAndPermissions }: RootState) =>
      rolesAndPermissions.apiState.addGroupToRoles.success
  )
  private addGroupsToRoleSuccessState!: boolean;

  @State(
    ({ rolesAndPermissions }: RootState) =>
      rolesAndPermissions.apiState.addGroupToRoles.error
  )
  private addGroupsToRoleErrorMessage!: string | null;

  @State(
    ({ rolesAndPermissions }: RootState) =>
      rolesAndPermissions.apiState.addGroupToRoles.error
  )
  private addGroupsToRoleErrorState!: boolean;

  @Action('application/getApplications')
  private getApplications!: () => Promise<void>;

  @State(({ application }: RootState) => application.apiState.getApplications)
  private getApplicationsState!: ApiState;

  @State(({ application }: RootState) => application.productApplications)
  private productApplications!: ApplicationItems;

  get products(): Product[] {
    return this.productApplications && this.productApplications.products
      ? this.productApplications.products.filter(
          (p) => p.isActive && !p.isDeleted
        )
      : [];
  }

  get SelectUserListComponent() {
    return SelectUserListComponent;
  }

  get SelectGroupListComponent() {
    return SelectGroupListComponent;
  }

  get ResourceTypes() {
    return ResourceTypes;
  }

  public isButtonDisable(): boolean {
    if (this.payload.resourceType === ResourceTypes.USER) {
      return (
        !this.payload.resourceIds.length && !this.newUserInvitesPayload.length
      );
    }
    if (this.payload.resourceType === ResourceTypes.GROUP) {
      return !this.payload.resourceIds.length;
    }
    return true;
  }

  public handleSelectedResources(resources: User[] | Group[]) {
    if (this.payload.resourceType === ResourceTypes.USER) {
      this.selectedResources = resources as User[];
      this.payload.resourceIds = this.selectedResources
        ? this.selectedResources.filter((r) => r.userId).map((r) => r.userId)
        : [];
      this.selectedUsers = this.selectedResources;
    }
    if (this.payload.resourceType === ResourceTypes.GROUP) {
      this.selectedResources = resources as Group[];
      this.payload.resourceIds = this.selectedResources
        ? this.selectedResources.map(
            (r) =>
              ({ groupId: r.id, typeName: r.types.name } as GroupIdTypeName)
          )
        : [];
    }
  }

  public handleSelectedRole(role: RoleSansTree[]) {
    this.selectedRoles = role;
    if (this.selectedUser) {
      this.payload.resourceIds = [this.selectedUser.userId];
    }
    if (this.selectedGroup) {
      this.payload.resourceIds = [
        { groupId: this.selectedGroup.id, typeName: this.selectedGroup.name }
      ];
    }
  }

  public openInviteNewUserForm(): void {
    this.stepsIndex = 1;
    this.getApplications();
  }

  public handleFormData(values: InviteUserFormValues) {
    this.formData = values;
  }

  public handleInviteButtonDisabledChange(newValue: boolean) {
    this.isInviteButtonDisable = newValue;
  }

  public handleInviteUser() {
    const { email, firstName, lastName, productId } = this.formData;
    if (email && firstName && lastName) {
      this.newUserInvitesPayload.push({
        email,
        firstName,
        lastName,
        productId
      });
      this.stepsIndex = 0;
      this.selectedUsers.push({
        email,
        firstName,
        lastName
      });
      this.userListComponentKey += 1;
      Toast.open({
        queue: true,
        position: 'is-top',
        message: `New user invitation drafted`,
        type: 'is-dark'
      });
    }
  }

  public closeModal(): void {
    this.$emit('close');
  }

  public prevStep(): void {
    this.stepsIndex -= 1;
  }

  public async handleAssignToRole(): Promise<void> {
    if (this.payload.resourceType === ResourceTypes.USER) {
      const payload: AddUsersToRoleDto = {
        existingUserIds: this.payload.resourceIds as number[],
        invitations: this.newUserInvitesPayload,
        roles: this.role
          ? [this.role.id]
          : this.selectedRoles.map((val) => val.id)
      };
      const jobs = await this.addUserToRoles({
        payload
      });
      this.$emit('roleUpdated', jobs);
      this.closeModal();
    } else if (this.payload.resourceType === ResourceTypes.GROUP) {
      const payload: AddGroupsToRoleDto = {
        payload: this.payload.resourceIds as GroupIdTypeName[],
        roles: this.role
          ? [this.role.id]
          : this.selectedRoles.map((val) => val.id)
      };
      const jobs = await this.addGroupToRoles({
        payload
      });
      this.$emit('roleUpdated', jobs);
      this.closeModal();
    }
  }

  @Watch('payload.resourceType')
  onResourceTypeChange(): void {
    this.payload.resourceIds = [];
    this.selectedUsers = [];
    this.newUserInvitesPayload = [];
  }

  @Watch('addUsersToRoleSuccessState')
  public async onAddUsersToRoleState(state: ApiState): Promise<void> {
    if (this.addUsersToRoleSuccessState) {
      Toast.open({
        queue: true,
        position: 'is-top',
        message: `User${this.selectedUser ? '' : '(s)'} assigned to role`,
        type: 'is-dark'
      });
      this.$emit('updateUsersAssignedCount');
      this.closeModal();

      if (this.newUserInvitesPayload.length > 0) {
        Toast.open({
          queue: true,
          position: 'is-top',
          message: `User(s) invitation sent successfully`,
          type: 'is-dark'
        });
      }
    }
  }

  @Watch('addUsersToRoleErrorState')
  public watchAddUsersToRoleErrorState() {
    if (this.addUsersToRoleErrorState) {
      let message = this.addUsersToRoleErrorMessage ?? '';
      /**
       * Error message is simplified. Original message shows user IDs which is
       * not actionable data for the user.
       */
      if (this.addUsersToRoleErrorMessage?.includes('already has')) {
        message = 'User(s) already assigned to role';
      }

      Toast.open({
        queue: true,
        position: 'is-top',
        message,
        type: 'is-danger'
      });
    }
  }

  @Watch('addGroupsToRoleSuccessState')
  public async onAddGroupsToRoleState(state: ApiState): Promise<void> {
    if (this.addGroupsToRoleSuccessState) {
      Toast.open({
        queue: true,
        position: 'is-top',
        message: `Group${this.selectedGroup ? '' : '(s)'}  assigned to role`,
        type: 'is-dark'
      });
      this.$emit('updateGroupsAssignedCount');
      this.$emit('roleUpdated');
      this.closeModal();
    }
  }

  @Watch('addGroupsToRoleErrorState')
  public watchAddGroupsToRoleErrorState() {
    if (this.addGroupsToRoleErrorState) {
      let message = this.addGroupsToRoleErrorMessage ?? '';
      if (this.addGroupsToRoleErrorMessage?.includes('already has')) {
        message = 'Group(s) already assigned to role';
      }
      Toast.open({
        queue: true,
        position: 'is-top',
        message,
        type: 'is-danger'
      });
    }
  }
}
